import {
  REQUEST_API,
  GET_RESPONSE_API,
    GET_ERROR_API
} from './constants';

export function requestAPI(urls, apikey, user) {
  return {
    type: REQUEST_API,
    data: {urls, apikey, user}
  }
}

export function getResponseAPI(data) {
  return {
    type: GET_RESPONSE_API,
    data
  }
}

export function getError(data) {
  return {
    type: GET_ERROR_API,
    data
  }
}
